var _circle, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 59.5,
    fill: "#DDF8ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.345 41.269V33h50.2v31.457m0 0 8.364 13.342H57.47m28.074-13.342H57.47",
    stroke: "#41CD8C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.571 84.894h19.99c1.421 0 2.572-1.124 2.572-2.51V46.908c0-1.386-1.151-2.514-2.572-2.514h-19.99c-1.42 0-2.571 1.123-2.571 2.514v35.478c0 1.385 1.15 2.509 2.571 2.509Z",
    stroke: "#41CD8C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.133 75.774H26",
    stroke: "#41CD8C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.547 47.693H36.58",
    stroke: "#41CD8C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.606 80.263c0 .514.43.932.955.932.53 0 .96-.418.96-.932s-.43-.932-.96-.932a.94.94 0 0 0-.955.932Z",
    stroke: "#41CD8C",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send_email.a1fc6d023d1d654c00eea42c44fac20e.svg";
export { ForwardRef as ReactComponent };